import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "dev-portal-action-button",

  imports: [CommonModule],
  template: `
    <button class="cursor-pointer rounded-lg p-1" [disabled]="disabled" [ngClass]="klass">
      <svg class="h-6 w-6">
        <use [attr.href]="icon" />
      </svg>
    </button>
  `,
  styles: [
    `
      :host {
        display: flex;
      }
    `
  ]
})
export class ActionButtonComponent {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input("class") klass =
    "text-day-text-icons-main dark:text-night-text-icons-main hover:dark:bg-night-bg-bg-2ry hover:bg-day-bg-bg-2ry disabled:dark:text-night-text-icons-gray-300 disabled:text-day-text-icons-gray-300";
  @Input() icon!: string;
  @Input() disabled = false;
}
